import type { RouteObject } from "react-router";
import { AUTH_ROUTES } from "../constants/auth-routes";

export const authRouter: RouteObject = {
	children: [
		{
			path: AUTH_ROUTES.LOGIN,
			lazy: async () => {
				const { default: LoginPage } = await import("../pages/login-page");
				return { Component: LoginPage };
			},
		},
	],
};
